<template>
    <el-dialog
        title="商品名称规范"
        :visible.sync="dialogVisible"
        width="800px"
        @close="handleClose"
    >
        <div class="productTitleStandardWrap">
            <div>
                商品分为标准商品和非标准商品两类<br/>
                标准商品：外包装含有upc条码的商品<br/>
                非标准商品：外包装无upc条码的商品、或无包装的生鲜类及自制商品等<br/>
            </div>
            <div class="title mt10">名称注意事项</div>
            <div style="padding-left: 20px;">
                <div>1）品名中<span class="red">不要加商家名称、价格、非商品信息（如：活动赠品、推广信息）</span></div>
                <div>2）商品包装单位以商品实际包装为准，生鲜商品无包装以“份”为单位，组合商品以“组”为单位</div>
            </div>
            <div class="title mt10">1、【标准商品规范】：<span class="red">（红色为必填）</span></div>
            <div><span class="red mt5">品牌</span>+子品牌+<span class="red">品名</span>+（商品描述，如：口味/型号等）<span class="red">+规格/包装单位</span></div>
            <el-table :data="list1" border class="mt5">
              <el-table-column prop="rule" label="商品名称示例"> </el-table-column>
              <el-table-column prop="brand" label="品牌"> </el-table-column>
              <el-table-column prop="subBrand" label="子品牌"></el-table-column>
              <el-table-column prop="name" label="品名"></el-table-column>
              <el-table-column prop="description" label="商品描述"></el-table-column>
              <el-table-column prop="spec" label="规格/包装单位" width="130"></el-table-column>
            </el-table>
            <div class="title mt10">2、【非标准商品规范】：<span class="red">（红色为必填）</span></div>
            <div>(特征属性，如：产地/果径)+<span class="red mt5">品名</span>+（数量）<span class="red">+约克重/包装单位</span></div>
            <el-table :data="list2" border class="mt5">
              <el-table-column prop="rule" label="商品名称示例">
                <template slot-scope="{row}">
                    <span v-html="row.rule"></span>
                </template>
              </el-table-column>
              <el-table-column prop="brand" label="品牌"> </el-table-column>
              <el-table-column prop="subBrand" label="子品牌"></el-table-column>
              <el-table-column prop="name" label="品名"></el-table-column>
              <el-table-column prop="description" label="商品描述"></el-table-column>
              <el-table-column prop="spec" label="规格/包装单位" width="130"></el-table-column>
            </el-table>
            <div class="title mt10">3、【单位注意事项】：</div>
            <div style="padding-left: 20px;">
                <div>1）千克使用小写字母kg，克使用小写字母g，毫升使用小写字母ml，升使用大写字母L；</div>
                <div>2）商品克重不足1kg以g为单位（例：0.5kg改为500g），商品克重1000g及以上以kg为单位（例：1000g改为1kg）；</div>
                <div>3）商品克重不足1L以ml为单位（例：0.5L改为500ml），商品克重1000ml及以上以L为单位（例：1000ml改为1L）；</div>
                <div>4）生鲜商品或散装商品名称不可使用区间规格如：300-400g、300±50g、300g/份±20g等，需使用格式为约300g；</div>
                <div>5）蛋糕类商品可以使用“磅”为克重单位；</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
// import { addCustomAttribute } from '@/servers/prod/center/shein.js';
export default {
  components: {

  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        dialogVisible: this.value,
        list1:[
            {
                rule:'伊利安慕希酸奶草莓味205g*6瓶/组',
                brand:'伊犁',
                subBrand:'安慕希',
                name:'酸奶',
                description:'草莓味',
                spec:'205g*6瓶/组'
            },
            {
                rule:'金龙鱼盘锦大米10kg/袋',
                brand:'金龙鱼',
                subBrand:'',
                name:'盘锦大米',
                description:'',
                spec:'10kg/袋'
            },
            {
                rule:'蒙牛红枣风味酸牛奶150g*5/包',
                brand:'蒙牛',
                subBrand:'',
                name:'红枣风味酸牛奶',
                description:'',
                spec:'150g*5/包'
            },
            {
                rule:'农夫山泉天然饮用水550ml*24*2/组',
                brand:'农夫山泉',
                subBrand:'',
                name:'天然饮用水',
                description:'',
                spec:'550ml*24*2/组'
            },
            {
                rule:'牛栏山52度百年白酒500ml/瓶',
                brand:'牛栏山',
                subBrand:'',
                name:'52度百年白酒',
                description:'',
                spec:'500ml/瓶'
            },
            {
                rule:'维达立体美无芯卷纸4层*18卷/提',
                brand:'维达',
                subBrand:'',
                name:'立体美无芯卷纸',
                description:'',
                spec:'4层*18卷/提'
            },
        ],
        list2:[
            {
                rule:'红富士苹果约<span class="red">500g/份</span>',
                brand:'',
                subBrand:'',
                name:'红富士',
                description:'',
                spec:'500g/份'
            },
            {
                rule:'鲜猪肉<span class="red">约1.5kg/份</span>',
                brand:'',
                subBrand:'',
                name:'鲜猪肉',
                description:'',
                spec:'1.5kg/份'
            },
            {
                rule:'散装鸡蛋<span class="red">600g/份</span>',
                brand:'',
                subBrand:'',
                name:'散装鸡蛋',
                description:'',
                spec:'600g/份'
            },
        ],
    };
  },
  methods: {
    handleClose() {
      this.$emit('input', false);
    }
  },
  watch: {
    value(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      this.$emit('input', newVal);
    }
  },
  created(){
  },
  mounted() {
   
  },
};
</script>

<style lang="scss" scope>
.productTitleStandardWrap{
    color: #333;
    font-size: 12px;
    .title{
        font-weight: 600;
    }
    .red{
        color: #ff3333;
    }
    .mt5{
        margin-top: 5px;
    }
    .mt10{
        margin-top: 10px;
    }
}
</style>
